export enum HighResolutionTimespanEnum {
  months = 'months',
  years = 'years',
}
